import formatDate from 'legacy/util/date/format-date';
import assetListManager from 'managers/asset-list-manager';
import toolboxManager from 'managers/toolbox-manager';
import exportPDFModel from 'models/export-pdf-model';
import {CONTENT_CARD_MAP_SIZE} from 'util/pdf-layout';

/*
 
localhost:8000/#projectId=p7FYWOflp0YzEW93f65l&siteId=lmj1zYZ4DlZNL9p0QoYe&position=top&view=pdf&type=contentCard&contentId=NQZ4zlPkQYvkyIuF1mSN&metric=&nw=-116.07505319551986,46.01365187286163&se=-116.05746308616904,46.004195904006565&projectViewId=7oELmKq65pWg1Ao-hPtt&bearing=0&pitch=0 

 */

// Hardcoded for special customer case UNEARTH-109 / UNEARTH-392
// Aside from Address & City, other controls must be set as "includeInContentRecordPDF" in the toolkit editor to show up on the export.

const SPECIAL_ADDRESS_ROW_FIELD_NAME = 'Address';
const SPECIAL_PROJECT_NUMBER_FIELD_NAME = 'Project Number';
const SPECIAL_COMMENTS_ROW_FIELD_NAME = 'If no - explain'; // According to spec, this should be full width.
const NO_VALUE = '--';

const ORDER_OF_HALF_WIDTH_PROPERTIES = [
    'City', 'Date', 'Pre - Camera Operator', 'Pre - Camera Locator', 'Post - Camera Operator', 'Post - Camera Locator'
];


const truncateCharacters = (value) => {
    if (value && value.length > 900) {
        return value.substring(0, 900) + '...';
    }
    return value;
};

const PDFExporterContentCard = {
    oncreate: ({state}) => {
        const assetId = exportPDFModel.isExportingContentCardFor;

        state.asset = assetListManager.getById(assetId);
        const normalizedProperties = {};
        // Some of the properties include extra white space after the dash, like in Pre - Camera Operator, and our key accessors can't pick them up.
        Object.entries(state.asset.properties).forEach(([key, value]) => {
            normalizedProperties[key.replace(/\s+/g, ' ').trim()] = value;
        });
        state.asset.properties = normalizedProperties;
        state.tool = toolboxManager.tools[state.asset.attributes.toolId];
        state.formattedUpdatedDate =  formatDate.dayMonthYear(state.asset.updatedDateTime);   
             
    },

    view: ({state: {asset, formattedUpdatedDate}}) => {
        return <div className="pdf-exporter-content-card-outer-wrap" style={`width:${CONTENT_CARD_MAP_SIZE.width}px`}>
            <div className="pdf-exporter-header-title">Vector Sewer Locate Card</div>
            {asset && <div className="pdf-exporter-content-card">
                <div className="form-control-row">
                    <div className="form-control-cell form-control-label">{SPECIAL_ADDRESS_ROW_FIELD_NAME}:</div>
                    <div className="form-control-cell form-control-value">{asset.properties[SPECIAL_ADDRESS_ROW_FIELD_NAME] || NO_VALUE}</div>
                </div>
                <div className="form-control-row">
                    <div className="form-control-cell form-control-label">{SPECIAL_PROJECT_NUMBER_FIELD_NAME}:</div>
                    <div className="form-control-cell form-control-value">{asset.properties[SPECIAL_PROJECT_NUMBER_FIELD_NAME] || NO_VALUE}</div>
                </div>
                {ORDER_OF_HALF_WIDTH_PROPERTIES.map(controlFieldName => {
                    return <div className="form-control-row">
                        <div className="form-control-cell form-control-label">{controlFieldName === 'Date' ? 'Date' : controlFieldName}:</div>
                        <div className="form-control-cell form-control-value">{(controlFieldName === 'Date' ? formattedUpdatedDate : asset.properties[controlFieldName]) || NO_VALUE}</div>
                    </div>;
                })}
                <div className="form-control-row form-control-row-full-width">
                    <div className="form-control-cell form-control-label">Comments</div>
                    <div className="form-control-cell form-control-value">{truncateCharacters(asset.properties[SPECIAL_COMMENTS_ROW_FIELD_NAME]) || NO_VALUE}</div>
                </div>
                
            </div>}
        </div>;
    }
};

export default PDFExporterContentCard;
